import { isSuccess } from '@carvana/merch-result';
import { axios } from '~/clients';
import { MerchUiApiClientId } from '~/constants/common/ApiClientId';
import { getGeocode } from '~/constants/endpoints';
import { ZipCodeInfo } from '~/contracts/common';
import { generateErrorLogger } from '~/utilities/loggers';

export default async function fetchGeocode(value: string) {
  const url = getGeocode({ currentPageUrl: window.location.href });

  return axios
    .get(`${url}?zip=${value}`, {
      headers: { 'x-client-id': MerchUiApiClientId }
    })
    .then(({ data }) => {
      if (isSuccess<ZipCodeInfo>(data)) {
        return data.content;
      }

      throw new Error('Geocode fetch failed');
    })
    .catch(generateErrorLogger('Geocode'));
}
